import React from 'react';
import App from './App';
import './FramedApp.scss';
import useWindowSize from './useWindowSize';

export default function FramedApp() {
  const windowSize = useWindowSize();

  return windowSize.width > 500 ? (
    <div className="FramedApp">
      <div className="FramedApp__iframe-wrapper">
        <iframe
          title={document.title}
          src={window.location.href}
          width="375"
          height="667"
          frameBorder="0"
        />
      </div>
    </div>
  ) : (
    <App />
  );
}
